import { gql } from "@apollo/client"
import { useSagaAuth } from "@einride/saga-core"
import { MetricFragment, useAvailableMetricsQuery } from "gen/graphql"
import { showErrorNotification } from "lib/notification/notification"
import { getActiveOrganization } from "lib/user"
import { useTranslation } from "react-i18next"

export const useAvailableMetrics = (): { data: MetricFragment[]; loading: boolean } => {
  const { t } = useTranslation()
  const auth = useSagaAuth()
  const { data, loading } = useAvailableMetricsQuery({
    variables: {
      request: {
        organization: getActiveOrganization(auth),
      },
    },
    onError: () => {
      showErrorNotification(t("common.reportErrorTitle"), t("common.reportErrorDescription"))
    },
  })
  return {
    data: data?.availableMetrics ?? [],
    loading,
  }
}

export const METRIC_FRAGMENT = gql`
  fragment Metric on Metric {
    metricId
    availableGroupAttributeIds
    availableFilterAttributeIds
    unit
    comparisons
    metricType
  }
`

export const AVAILABLE_METRICS_QUERY = gql`
  query availableMetrics($request: GetAvailableMetricsRequest!) {
    availableMetrics(request: $request) {
      ...Metric
    }
  }
`

export function getMetricConfiguration(
  metric: string | undefined,
  availableMetrics: MetricFragment[],
): MetricFragment | undefined {
  return availableMetrics.find((availableMetric) => availableMetric.metricId === metric)
}
